/** @file Where the brush ring is drawn: the last hover or stroke pointer (screen px; null = off canvas). */
import type { Vec2 } from '@pose2d/math/types';

/** Written by paintWeightsPointer.hover and strokes, read by its idle drawing; one viewport per page. */
export const brushCursor: { at: Vec2 | null } = { at: null };
